import { SaleType, UserProfileApiClient } from '@wix/package-picker-sdk';
import { useCurrentModule } from '../components/ModuleProvider';
import { QUICK_PAY_LIGHTBOX_SPEC } from '../utils/consts';
export const NEW_USER_MAX_AGE_DAYS = 7;
const MS_PER_DAY = 24 * 60 * 60 * 1000;
export const daysSinceRegistration = function (registrationDate, now) {
  if (now === void 0) {
    now = Date.now();
  }
  if (!registrationDate) {
    return undefined;
  }
  const registeredAt = new Date(registrationDate).getTime();
  if (Number.isNaN(registeredAt)) {
    return undefined;
  }
  return (now - registeredAt) / MS_PER_DAY;
};
export const useWelcomeGiftAudience = () => {
  var _discountData$discoun;
  const module = useCurrentModule();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const {
    data: discountData
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOfferingDiscount({});
  const isSpecEnabled = experiments.isEnabled(QUICK_PAY_LIGHTBOX_SPEC);
  const isPersonalSale = Boolean(discountData == null ? void 0 : discountData.hasSale) && (discountData == null || (_discountData$discoun = discountData.discount) == null || (_discountData$discoun = _discountData$discoun.discountInfo) == null || (_discountData$discoun = _discountData$discoun.sale) == null ? void 0 : _discountData$discoun.saleType) === SaleType.PERSONAL_SALE;
  const {
    data
  } = UserProfileApiClient.hooks.useGetRegistrationDate({}, isSpecEnabled && isPersonalSale);
  if (!isSpecEnabled || !isPersonalSale) {
    return undefined;
  }
  const age = daysSinceRegistration(data == null ? void 0 : data.registrationDate);
  if (age === undefined || age < 0) {
    return undefined;
  }
  return age < NEW_USER_MAX_AGE_DAYS ? 'new' : 'returning';
};
//# sourceMappingURL=useWelcomeGiftAudience.js.map